import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { BackArrowIcon } from "../../../components/Svg";
import { ModalTypes, Urls } from "../../../constants";
import { AiTab, AiTabs } from '../../../components/AiTabs';
import UIState, { selectMobileLayout } from '../../../store/UIState';
import { useParams } from "react-router";
import Ai, {
  selectAllstandardTemplates,
  selectDeploymentTemplate,
  selectOndemandModels,
} from '../../../store/models/Ai';
import classNames from 'classnames';
import { useLocation } from "react-router";
import { getQueryParams, mergeUrl } from "../../../utils/url";
import { Button } from '../../../components/Button';
import { Link } from "react-router-dom";
import { ShowcaseImageToImage } from '../../../components/ai-showcases/ShowcaseImageToImage';
import { ShowcaseChatbot } from '../../../components/ai-showcases/ShowcaseChatbot';
import { ShowcaseComingSoon } from '../../../components/ai-showcases/ShowcaseComingSoon';
import { AIShowcase, selectShowcases } from '../../../store/models/AIShowcase';
import { ShowcaseTextToImage } from '../../../components/ai-showcases/ShowcaseTextToImage';
import { ShowcaseImageToVideo } from '../../../components/ai-showcases/ShowcaseImageToVideo';
import { ShowcaseTalkingHead } from '../../../components/ai-showcases/ShowcaseTalkingHead';
import OndemandApiTab from '../../../components/ai/OndemandApiTab';
import OndemandTokenTab from '../../../components/ai/OndemandTokenTab';
import { AiOndemandApi, selectApiKeys } from '../../../store/models/AiOndemandApi';
import Loader from '../../../components/Loader';
import { ShowcaseAudioToText } from '../../../components/ai-showcases/ShowcaseAudioToText';
import { ShowcaseImageToText } from '../../../components/ai-showcases/ShowcaseImageToText';
import { ShowcaseTextToAudio } from '../../../components/ai-showcases/ShowcaseTextToAudio';
import { ShowcaseViton } from '../../../components/ai-showcases/ShowcaseViton';
import { ShowcaseTextToVideo } from '../../../components/ai-showcases/ShowcaseTextToVideo';
import { ShowcaseAudioToAudio } from '../../../components/ai-showcases/ShowcaseAudioToAudio';

const DateOptions = {
  month: 'short',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};

function OndemandModelDetailPage({ }) {
  const dispatch = useDispatch();
  const params = useParams();
  const { projectId, id } = params;
  const { templates, services } = useSelector(state => selectOndemandModels(state, projectId));
  const template = templates.find(s => s.id === id);
  const templateName = _.get(template, 'name');
  const isMobile = useSelector(state => selectMobileLayout(state));
  const apiKeys = useSelector(state => selectApiKeys(state));
  const [selectedTab, setSelectedTab] = useState('playground')
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const service = services.find(s => s.template_id === template.id);
  let unit = 'call', isPriceSplit = false;
  let inputUnit = 'call', outputUnit = 'call';
  let inputAmount = 1, outputAmount = 1;
  if (service) {
    let prediction = _.get(Object.values(_.get(service, 'predictions')), '0');
    inputAmount = _.get(prediction, 'cost.input');
    outputAmount = _.get(prediction, 'cost.output');
    let instructions = _.get(prediction, 'instructions');
    if (instructions) {
      try {
        let instructionsJson = JSON.parse(instructions);
        isPriceSplit = instructionsJson.isPriceSplit;
        if (isPriceSplit) {
          inputUnit = instructionsJson.inputUnit;
          outputUnit = instructionsJson.outputUnit;
        } else {
          unit = instructionsJson.unit;
        }
      } catch (e) {
        console.log('e:', e.message);
      }
    }
  }

  const sumAmountPrice = inputAmount + outputAmount;
  const priceSection = isPriceSplit
    ? <>
      <p>{`${isMobile ? '' : `Price: `}$${Number(inputAmount / 100).toFixed(2)} / ${inputUnit}`}</p>
      <p style={{ marginTop: '10px' }}>{`$${Number(outputAmount / 100).toFixed(2)} / ${outputUnit}`}</p>
    </> : `${isMobile ? '' : `Price: `}$${Number(sumAmountPrice / 100).toFixed(2)} / ${unit}`

  useEffect(() => {
    if (template) return;
    fetchData();

    async function fetchData() {
      try {
        setLoading(true);
        await dispatch(Ai.actions.fetchOndemandServiceById(id));
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    }
  }, [template])

  useEffect(() => {
    (async () => {
      try {
        await dispatch(AiOndemandApi.actions.fetchModelApiKeys(projectId));
        await dispatch(Ai.actions.fetchDeploymentTemplate(id))
      } catch (e) {
        console.log('Error:', e.message)
      }
    })()
  }, [projectId])

  // for short descriptions
  const modelTemplate = useSelector(state => selectDeploymentTemplate(state))

  //console.log(modelTemplates)

  return (<div className={'AiServicePage AiServicePage--with-back-button'}>
    <Link to={mergeUrl(Urls.AI_ON_DEMAND_MODEL_APIS, { projectId })}>
      <div className={'AiServicePage__back-button on-demand'}>
        <BackArrowIcon />
        <div className={'AiServicePage__back-button--label'}>
          On-demand Model APIs
        </div>
      </div>
    </Link>
    <AiTabs className="AiServicePage__ondemand-tabs">
      <AiTab isSelected={(selectedTab === 'playground')}
        onClick={() => {
          setSelectedTab('playground')
        }}>
        Playground
      </AiTab>
      <AiTab isSelected={(selectedTab === 'api')}
        onClick={() => {
          setSelectedTab('api')
        }}>
        API
      </AiTab>
      <AiTab isSelected={(selectedTab === 'token')}
        onClick={() => {
          setSelectedTab('token')
        }}>
        Access Token
      </AiTab>
      <div className={classNames('AiServicePage__tab-price', { 'isPriceSplit': isPriceSplit })}>
        {priceSection}
      </div>
    </AiTabs>
    {selectedTab === 'playground' && <div>
      {/* {getPlayground(serviceName)} */}
      <div className='short-description'>{modelTemplate?.short_description}</div>
      <Playground name={templateName} apiKeys={apiKeys} loading={loading} />
    </div>}
    {selectedTab === 'api' && <>
      {getApi(templateName, setSelectedTab)}
    </>}
    {selectedTab === 'token' && <OndemandTokenTab />}
  </div>
  );
}

export default OndemandModelDetailPage;

const Playground = ({ name, apiKeys, loading }) => {
  if (loading) return <Loader />;
  else {
    switch (name) {
      case 'Image to Image':
        return <ShowcaseImageToImage showcases={[]} className='on-demand' mName={'img-to-img'} />
      case 'FLUX.1-schnell':
        return <ShowcaseTextToImage showcases={[]} className='on-demand' mName={'flux'} />
      case 'Stable Diffusion XL Turbo':
        return <ShowcaseTextToImage showcases={[]} className='on-demand' mName={'SDXL'} />
      case 'Stable Diffusion Turbo Vision':
        return <ShowcaseTextToImage showcases={[]} className='on-demand' mName={'SD'} />
      case 'Llama 3.1 70B Instruct':
        return <ShowcaseChatbot showcases={[]} className='on-demand' mName={'llama-3-1-70b'} />
      case 'Llama 3 8B Instruct':
        return <ShowcaseChatbot showcases={[]} className='on-demand' mName={'llama-3-8b'} />
      case 'DeepSeek R1 / Distill-Qwen-7B':
        return <ShowcaseChatbot showcases={[]} className='on-demand' mName={'deepseek-r1'} />
      case 'Stable Diffusion Video':
        return <ShowcaseImageToVideo showcases={[]} className='on-demand' mName={'SDV'} />
      case 'Whisper':
        return <ShowcaseAudioToText showcases={[]} className='on-demand' mName={'whisper'} />
      case 'Talking Head':
        return <ShowcaseTalkingHead showcases={[]} className='on-demand' mName={'talking-head'} />
      case 'ESRGAN':
        return <ShowcaseImageToImage showcases={[]} className='on-demand' mName={'esrgan'} />
      case 'Blip':
        return <ShowcaseImageToText showcases={[]} className='on-demand' mName={'blip'} />
      case 'Grounding Dino':
        return <ShowcaseImageToImage showcases={[]} className='on-demand' mName={'grounding-dino'} />
      case 'Kokoro 82M':
        return <ShowcaseTextToAudio showcases={[]} className='on-demand' mName={'kokoro-82m'} />
      case 'StableVITON':
        return <ShowcaseViton showcases={[]} className='on-demand' mName={'SV'} />
      case 'StepFun AI / StepVideo':
        return <ShowcaseTextToVideo showcases={[]} className='on-demand' mName={'step-video'} />
      case 'InstantX / InstantID':
        return <ShowcaseImageToImage showcases={[]} className='on-demand' mName={'instant-id'} />
      case 'Voice Cloning':
        return <ShowcaseAudioToAudio showcases={[]} className='on-demand' mName={'voice-cloning'} />
      default:
        return <ShowcaseComingSoon />
    }
  }
}

const getApi = (name, setSelectedTab) => {
  switch (name) {
    case 'Stable Diffusion XL Turbo':
    case 'Stable Diffusion Turbo Vision':
    case 'Stable Diffusion Video':
    case 'FLUX.1-schnell':
    case 'Whisper':
    case 'Image to Image':
    case 'Llama 3 8B Instruct':
    case 'Llama 3.1 70B Instruct':
    case 'DeepSeek R1 / Distill-Qwen-7B':
    case 'Talking Head':
    case 'ESRGAN':
    case 'Blip':
    case 'Grounding Dino':
    case 'Kokoro 82M':
    case 'StableVITON':
    case 'StepFun AI / StepVideo':
    case 'InstantX / InstantID':
    case 'Voice Cloning':
      return <OndemandApiTab model={name} setSelectedTab={setSelectedTab} />
    default:
      return <ShowcaseComingSoon />
  }
}

